export default {
  label: {
    computer: 'Computadora',
    mobile: 'Celular/Tablet',
    notClassified: 'No Clasificado',
  },
};
